/**
 * MSAL (Microsoft Authentication Library) Configuration
 *
 * This configuration enables OAuth2 Authorization Code Flow with PKCE
 * for secure authentication with Microsoft Entra ID (Azure AD).
 */

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_ENTRA_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false, // Set to true for IE11 or Edge support
  },
  system: {
    loggerOptions: {
      loggerCallback: () => {
        // Completely disable all MSAL logging
        return;
      },
    },
  },
};

/**
 * Scopes for login request
 * - openid: Required for ID token
 * - profile: User profile information
 * - email: User email address
 * - Custom API scope: Access to PABLO backend API
 */
export const loginRequest = {
  scopes: process.env.REACT_APP_ENTRA_SCOPE.split(' '),
};

/**
 * Scopes for token acquisition (silent or interactive)
 */
export const tokenRequest = {
  scopes: process.env.REACT_APP_ENTRA_SCOPE.split(' '),
};
